import { useEffect, useState } from "react";
import api from "../../../../services/api";

import Notification from "../../../../components/toast";
import { useForm } from "react-hook-form";
import functions from "../../../../util/functions";
import { zodResolver } from "@hookform/resolvers/zod";
import { schema } from "./schema";
import LibBoolean from "../../../../util/libBool";
import reqTipoProduto from "../../../../services/reqMultiTenant/reqTipoProduto";

export const IndexHook = ({
	id_tipoproduto,
	isOpenModalRegister,
	handleCloseModalRegister,
	setCategoryData,
	categoryData,
}) => {
	// const {
	// 	id_tipoproduto,
	// 	isOpenModalRegister,
	// 	handleCloseModalRegister,
	// 	setCategoryData,
	// 	categoryData,
	// } = useContext(ContextRegisterCategory);

	const {
		register,
		handleSubmit,
		setValue,
		setFocus,
		setError,
		reset,
		control,
		formState: { errors, isSubmitting },
	} = useForm({
		mode: "all",
		//quando revalidar os campos
		// reValidateMode: "onChange",
		resolver: zodResolver(schema),
		defaultValues: {
			id_tipoproduto: 0,
			nome: "",
			ordem: 0,
			ativo: true,
			obs: "",
		},
	});

	const [loading, setLoading] = useState(false);

	//#region Fetch
	useEffect(() => {
		if (isOpenModalRegister) {
			fetchCategory();
		} else {
			reset();
		}
	}, [isOpenModalRegister]);

	const fetchCategory = async () => {
		try {
			setLoading(true);
			try {
				if (id_tipoproduto > 0) {
					const response = await reqTipoProduto.listID(id_tipoproduto);

					if (typeof response.data === "object" && response.data !== null) {
						const data = response.data;

						const newData = await processNewData(data);

						Object.keys(newData).forEach((field) => {
							setValue(field, newData[field]);
						});
					}
				}
			} catch (error) {
				Notification.showToast({
					message: error.message,
					type: "warning",
				});
				handleCloseModalRegister();
			}
		} finally {
			setLoading(false);
		}
	};

	const processNewData = async (data) => {
		return {
			...data,
			ativo: LibBoolean.strToBoolean(data.ativo),
		};
	};
	//#endregion

	//#region onSubmit
	const handleOnSubmit = async (data) => {
		try {
			const newAtivo = LibBoolean.booleanToStr(data.ativo);
			// const auth = functions.sessionAuth();

			const newData = {
				...data,
				ativo: newAtivo,
				// auth,
			};

			const response = await reqTipoProduto.insert(newData);

			const currentId = response.data[0].id_tipoproduto;

			await reloadData(currentId);
			// // Sucesso
			Notification.showToast({
				message: "Registro salvo com sucesso.",
				type: "success",
			});

			reset();
			handleCloseModalRegister();
		} catch (error) {
			if (error.field) {
				errosAfterPost(error.field, error.message);
			} else
				Notification.showToast({
					message: error.message,
					type: "error",
				});
		}
	};

	const handleChangeInt = (e) => {
		try {
			let value = e.target.value.trim();
			if (value === "") {
				value = 0;
			} else {
				value = parseInt(e.target.value, 10);
			}
			setValue(e.target.name, value);
		} catch {
			setValue(e.target.name, 0);
		}
	};

	const reloadData = async (currentId) => {
		try {
			//lista o cliente no qual foi feita a inserção ou alteração
			const response = await reqTipoProduto.listID(currentId);

			//pego somente o primeiro pq neste caso mando sempre 1 resgistro por vez
			if (typeof response.data === "object" && response.data !== null) {
				const responseData = response.data;

				//se é inserção ou alteração. Inserção só adiciona mais um registro no array
				if (id_tipoproduto === 0) {
					setCategoryData((prevState) => [...prevState, responseData]);
				} else {
					//se for update ele procura na lista aonde ta o cliente que foi selecionado e altera somente ele
					const newCategoryData = categoryData.map((item) => {
						if (item.id_tipoproduto === responseData.id_tipoproduto) {
							return responseData;
						}
						return item;
					});
					setCategoryData(newCategoryData);
				}
			}
		} catch (error) {
			console.log(error.message);
		}
	};

	const errosAfterPost = (field, message) => {
		setError(field?.toLowerCase(), { type: "manual", message: message });
	};

	//#endregion

	return {
		//hooks
		handleOnSubmit,
		handleChangeInt,
		loading,

		id_tipoproduto,

		//context
		isOpenModalRegister,
		handleCloseModalRegister,

		//useForm
		register,
		handleSubmit,

		setValue,
		control,
		setFocus,

		//formState
		errors,
		isSubmitting,
	};
};
